import { CST } from '../CST';
import { data } from 'jquery';
import card from '../model/card.js';
import config from '../helpers/config.js';
import { language } from './language';
import { Controller } from '../controller/controller.js';
import $ from 'jquery';

let time_left;
let time_timer;
let timer;
let duration;
let timerBox;
let started = false;
let timerStarted = false;

export default class BoardViewOnly extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.BOARDONLYVIEW);
	}

	init() {
		this.self = self;
	}

	async preload() {
		this.load.image('bg', 'assets/english/bg.png');
		this.load.image('clock', 'assets/english/clock.png');
		this.load.image('overlay', 'assets/english/overlay.png');
		this.load.image('black_bg', 'assets/english/black_screen.png');
		this.load.image('backCardScenario', 'assets/english/scenario-card-back.png');
		this.load.image('times_up', 'assets/english/times-up.png');
		this.load.image('game_over', 'assets/english/game_over.png');
		this.load.image('close_btn', 'assets/english/close.png');
		this.load.image('popup-player-tab', 'assets/popup-player-tab.png');
		this.load.spritesheet({
			key: 'cardFlipScenario',
			url: 'assets/card-flip-scenario.png',
			frameConfig: { frameWidth: 758.68, frameHeight: 794 },
		});
		this.load.spritesheet({
			key: 'cardFlipFeedback',
			url: 'assets/card-flip-feedback.png',
			frameConfig: { frameWidth: 758.68, frameHeight: 794 },
		});
		this.load.spritesheet({
			key: 'roulette-sprite',
			url: 'assets/english/roulette.png',
			frameConfig: { frameWidth: 751.67, frameHeight: 813 },
		});
		this.load.spritesheet({
			key: 'firework-blue',
			url: 'assets/firework-blue.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		this.load.spritesheet({
			key: 'firework-red',
			url: 'assets/firework-red.png',
			frameConfig: { frameWidth: 384.03, frameHeight: 385 },
		});
		for (let i = 1; i <= 28; i++) {
			this.load.image('scenario' + i, 'assets/english/cards/scenario (' + i + ').png');
			this.load.image(
				'zoom-scenario' + i,
				'assets/english/cards/eng-expanded/cardZoom-scenario (' + i + ').png',
			);
			this.load.image('feedback' + i, 'assets/english/cards/feedback (' + i + ').png');
			this.load.image(
				'zoom-feedback' + i,
				'assets/english/cards/eng-expanded/cardZoom-feedback (' + i + ').png',
			);
		}
	}

	create(data) {
		this.showPlayerPopup();
		const chatChannel = new BroadcastChannel('chat_channel');

		chatChannel.onmessage = event => {
			const data = JSON.parse(event.data);

			switch (data.action) {
				case 'timer':
					duration = data.time;
					time_left = duration;

					switch (duration) {
						case 120:
							timer = this.add
								.text(this.cameras.main.width / 2 - 5, 37, '2:00', CST.TEXTSTYLES.TIMERSTYLE)
								.setDepth(2);
							break;
						case 300:
							timer = this.add
								.text(this.cameras.main.width / 2 - 5, 37, '5:00', CST.TEXTSTYLES.TIMERSTYLE)
								.setDepth(2);
							break;
						case 420:
							timer = this.add
								.text(this.cameras.main.width / 2 - 5, 37, '7:00', CST.TEXTSTYLES.TIMERSTYLE)
								.setDepth(2);
							break;
						case 600:
							timer = this.add
								.text(this.cameras.main.width / 2 - 5, 37, '10:00', CST.TEXTSTYLES.TIMERSTYLE)
								.setDepth(2);
							break;
					}
					break;
				case 'start-timer':
					time_timer = this.scene.scene.time.now;
					started = true;
					timerStarted = true;
					break;
				case 'rules':
					this.scene.pause();
					this.scene.launch(CST.SCENES.RULES1, { scene: CST.SCENES.BOARD });
					break;
				case 'fireworks':
					this.startFireworks();
					break;
				case 'card-flip':
					this.cardFlip(
						data.key,
						data.zoomKey,
						data.rndFunActivity,
						data.rndQuestion,
						data.rndFunGroupActivity,
						data.rndQuestionGroup,
					);
					break;
				case 'card-flip2':
					this.cardFlip2(
						data.key,
						data.zoomKey,
						data.rndFunActivity,
						data.rndQuestion,
						data.rndFunGroupActivity,
						data.rndQuestionGroup,
					);
					break;
				case 'card-zoom':
					this.cardZoom(data.zoomKey);
					break;
				case 'card-zoom2':
					this.cardZoom2(data.zoomKey);
					break;
				case 'card-zoom-close':
					this.blackBg.destroy();
					this.zoomCard.destroy();
					this.timerBox2.destroy();
					timer.x = this.cameras.main.width / 2 - 5;
					timer.y = 37;
					break;
				case 'next-cs':
					this.resetTimer();

					this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0, 0).setScale(2).setDepth(1.2);
					this.roulette = this.add
						.sprite(this.cameras.main.width / 2, this.cameras.main.height / 2, 'roulette-sprite')
						.setDepth(2)
						.play('roulette-spin');

					this.time.delayedCall(2000, () => {
						this.roulette.destroy();
						this.overlay.destroy();
						this.card.destroy();
						this.card2.destroy();
						this.backCard.setVisible(true);

						this.card.setPosition(this.cameras.main.width / 2, this.cameras.main.height / 2);
						this.card2.setPosition(this.cameras.main.width / 2, this.cameras.main.height / 2);
					});
					break;
				case 'times-up': {
					const timesUpImg = this.add
						.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'times_up' + language)
						.setDepth(2);
					setTimeout(() => {
						timesUpImg.destroy();
					}, 2500);
					break;
				}
				case 'end-game':
					this.add
						.image(
							this.cameras.main.width / 2,
							this.cameras.main.height / 2,
							'game_over' + language,
						)
						.setDepth(2);

					setTimeout(() => {
						this.scene.start(CST.SCENES.ENDSCREENCLIENT, {
							scene: CST.SCENES.BOARDONLYVIEW,
							data: data.data,
						});
					}, 2500);
					break;
				default:
					break;
			}
		};

		this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg' + language)
			.setScale(1);

		this.anims.create({
			key: 'flip',
			frames: this.anims.generateFrameNames('cardFlipScenario'),
			frameRate: 60,
			repeat: 0,
		});

		this.anims.create({
			key: 'flip2',
			frames: this.anims.generateFrameNames('cardFlipFeedback'),
			frameRate: 60,
			repeat: 0,
		});

		this.anims.create({
			key: 'roulette-spin',
			frames: this.anims.generateFrameNumbers('roulette-sprite'),
			frameRate: 15,
			repeat: -1,
		});

		timerBox = this.add.image(this.cameras.main.width / 2, 48, 'clock');

		this.backCard = this.add.sprite(
			this.cameras.main.width / 2 /*- 370*/,
			this.cameras.main.height / 2 + 25,
			'backCardScenario' + language,
		);
	}

	update(time, delta) {
		if (started && time_left > 0) {
			const elapsed = (time - time_timer) / 1000;
			time_left = duration - elapsed;

			const minutes = Math.floor(time_left / 60);
			const seconds = Math.floor(time_left % 60);

			const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
			timer.setText(formattedTime);

			if (time_left <= 0) {
				timer.setText('0:00');
			}
		}
	}

	resetTimer() {
		if (timer) {
			timer.destroy();
		}
		time_left = 0;
		duration = 0;
		started = false;
		timerStarted = false;
	}

	cardFlip(key) {
		this.backCard.setVisible(false);
		const cardAnim = this.add
			.sprite(this.backCard.x, this.cameras.main.height / 2 + 25, 'backCardScenario' + language)
			.play('flip');
		this.card = this.add
			.image(this.backCard.x, this.cameras.main.height / 2 + 25, '')
			.setVisible(false)
			.setDepth(0.9);

		cardAnim.on('animationcomplete', () => {
			this.card.setTexture(key);
			this.card.setVisible(true);

			cardAnim.destroy();
		});
	}

	cardFlip2(key) {
		this.tweens.add({
			targets: this.card,
			x: this.cameras.main.width / 2 - 370,
			duration: 1000,
			ease: 'Power2',
		});

		this.card2 = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 25, key)
			.setVisible(true)
			.setDepth(0.8);

		this.tweens.add({
			targets: this.card2,
			x: this.cameras.main.width / 2 + 370,
			duration: 1000,
			ease: 'Power2',
		});
	}

	cardZoom(zoomKey) {
		this.timerBox2 = this.add
			.image(this.cameras.main.width / 2 - 650, this.cameras.main.height / 2 + 400, 'clock')
			.setDepth(1.9);

		timer.x = this.cameras.main.width / 2 - 650;
		timer.y = this.cameras.main.height / 2 + 389;

		this.blackBg = this.add
			.image(0, 0, 'black_bg')
			.setOrigin(0, 0)
			.setScale(2)
			.setAlpha(0.8)
			.setDepth(1);

		this.zoomCard = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 15, zoomKey + language)
			.setDepth(2)
			.setScale(1);
	}

	cardZoom2(zoomKey) {
		this.timerBox2 = this.add
			.image(this.cameras.main.width / 2 - 650, this.cameras.main.height / 2 + 400, 'clock')
			.setDepth(1.9);

		timer.x = this.cameras.main.width / 2 - 650;
		timer.y = this.cameras.main.height / 2 + 389;

		this.blackBg = this.add
			.image(0, 0, 'black_bg')
			.setOrigin(0, 0)
			.setScale(2)
			.setAlpha(0.8)
			.setDepth(1);

		this.zoomCard = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 - 15, zoomKey + language)
			.setDepth(2)
			.setScale(1);
	}

	startFireworks() {
		let self = this;
		const getRandomNumber = (min, max) => Math.random() * (max - min) + min;

		this.anims.create({
			key: 'anim-firework-blue',
			frames: this.anims.generateFrameNames('firework-blue'),
			frameRate: 30,
			repeat: 0,
		});

		this.anims.create({
			key: 'anim-firework-red',
			frames: this.anims.generateFrameNames('firework-red'),
			frameRate: 30,
			repeat: 0,
		});

		(function loop(times) {
			setTimeout(
				() => {
					const firework = self.add
						.sprite(getRandomNumber(150, 1400), getRandomNumber(150, 909), 'firework-blue')
						.setDepth(2)
						.play('anim-firework-blue');
					firework.on('animationcomplete', () => {
						firework.destroy();
					});

					if (--times) loop(times); //  decrement i and call myLoop again if i > 0
				},
				getRandomNumber(500, 1000),
			);
		})(10);

		(function loop(times) {
			setTimeout(
				() => {
					const firework = self.add
						.sprite(getRandomNumber(150, 1400), getRandomNumber(150, 909), 'firework-red')
						.setDepth(2)
						.play('anim-firework-red');
					firework.on('animationcomplete', () => {
						firework.destroy();
					});
					if (--times) loop(times); //  decrement i and call myLoop again if i > 0
				},
				getRandomNumber(500, 1000),
			);
		})(10);
	}

	showPlayerPopup() {
		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		const overlay = this.add.rectangle(cx, cy, 1500, 929, 0x000000, 0.6).setDepth(100);
		const popup = this.add.image(cx, cy, 'popup-player-tab').setDepth(101);
		const btnClose = this.add
			.image(cx, cy + 185, 'close_btn')
			.setInteractive({ useHandCursor: true })
			.setDepth(102)
			.on('pointerdown', () => {
				overlay.destroy();
				popup.destroy();
				btnClose.destroy();
			});
	}
}
